import React, { useCallback } from 'react'
import classnames from 'classnames'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import MultiSelectBox from '../../../../../../features/components/Form/MultiSelectBox'
import FieldLabelWrapper from '../../../../../../features/components/Form/FieldLabelWrapper'
import Checkbox from '../../../../../../components/Form/Checkbox'
import FacebookAgesRange from '../../../../AgeRangesFields/FacebookAgesRange'
import MessageBlock from '../../../../../../features/components/Form/MessageBlock'
import BehavioursSelect from './BehavioursSelect'

import { useLoadFacebookInterests } from '../../../../../Facebook/hooks'

import { choicesInterestsLoadingSelector } from '../../../../../../modules/selectors/choices'

import { CUSTOM_AUDIENCES_EXCLUSION } from '../../../AudiencesFields/fields'
import { FEMALE, MALE } from '../../../../../Facebook/fields'
import { INTERESTS } from '../../../../InterestsFields/fields'

import useDrawerFormStyles from '../../../../../../styles/common/drawerForms'
import useAdvancedAudienceTargetingSectionStyles from '../../../../../../styles/common/styles'
import { BEHAVIORS } from './BehavioursSelect/fields'

const AdvancedAudienceTargetingSection = ({ formik, audiencesIsLoading, formattedAudiences }) => {
  const { t } = useTranslation()

  const { values, setFieldValue } = formik

  const interestsLoading = useSelector(choicesInterestsLoadingSelector)

  const { formattedInterests, searchInterests } = useLoadFacebookInterests()

  const checkboxHandler = useCallback(
    e => {
      const { name } = e.target
      setFieldValue(name, !values[name])
    },
    [values, setFieldValue]
  )

  const drawerFormClasses = useDrawerFormStyles()
  const classes = useAdvancedAudienceTargetingSectionStyles()

  return (
    <section className={drawerFormClasses.section}>
      <h3 className={classnames(drawerFormClasses.sectionTitle, classes.sectionTitle)}>
        {t('Advanced audience targeting')}
      </h3>
      <FieldLabelWrapper label={t('Exclude an audience')} className={classes.subsection}>
        <MultiSelectBox
          placeholder={t('Select an audience...')}
          options={formattedAudiences}
          value={values[CUSTOM_AUDIENCES_EXCLUSION]}
          name={CUSTOM_AUDIENCES_EXCLUSION}
          isLoading={audiencesIsLoading}
          setFieldValue={setFieldValue}
        />
      </FieldLabelWrapper>

      <FieldLabelWrapper label={t('Gender')} className={classes.subsection}>
        <div className={classes.genderCheckboxes}>
          <Checkbox
            id={MALE}
            name={MALE}
            checked={values[MALE]}
            title="Male"
            className={classes.genderCheckbox}
            onCheck={checkboxHandler}
          />
          <Checkbox
            id={FEMALE}
            name={FEMALE}
            checked={values[FEMALE]}
            title="Female"
            className={classes.genderCheckbox}
            onCheck={checkboxHandler}
          />
        </div>
      </FieldLabelWrapper>

      <FieldLabelWrapper label={t('Ages')} className={classes.subsection}>
        <FacebookAgesRange formik={formik} />
      </FieldLabelWrapper>

      <FieldLabelWrapper label={t('Interests')} className={classes.subsection}>
        <MultiSelectBox
          name={INTERESTS}
          options={formattedInterests}
          value={values[INTERESTS]}
          isLoading={interestsLoading}
          onSearch={searchInterests}
          setFieldValue={setFieldValue}
        />
        {values[INTERESTS]?.length > 0 && (
          <MessageBlock title="This will significantly reduce your audience size" borderColor="warning">
            {t(
              'Adding an interest audience will reduce your targeting further and your audience size might end up very small.'
            )}
          </MessageBlock>
        )}
      </FieldLabelWrapper>
      <FieldLabelWrapper label={t('Behaviours')} className={classes.subsection}>
        <BehavioursSelect formik={formik} />
        {values[BEHAVIORS]?.length > 0 && (
          <MessageBlock title="This will significantly reduce your audience size" borderColor="warning">
            {t(
              'Adding a behaviour audience will reduce your targeting further and your audience size might end up very small.'
            )}
          </MessageBlock>
        )}
      </FieldLabelWrapper>
    </section>
  )
}

export default AdvancedAudienceTargetingSection
